<script setup>
import { ref } from 'vue'
import Button from '@components/global/button.vue'
import Input from '@components/global/input.vue'

const processing = ref(false)
const success = ref(false)
const user = ref({})
const errors = ref({})

function submit(form) {
	form.preventDefault()
	if (!processing.value) {
		processing.value = true
		axios
			.post('/api/newsletter', user.value)
			.then(() => {
				errors.value = {}
				processing.value = false
				success.value = true
			})
			.catch((error) => {
				processing.value = false
				success.value = false
				if (error.response.status === 422) errors.value = error.response.data.errors
			})
	}
}
</script>

<template>
	<div class="relative bg-bgSecondary">
		<section class="container flex justify-center">
			<div class="content absolute-x-center -top-4 flex items-center justify-center overflow-hidden rounded-full bg-bgSecondary p-2">
				<div class="flex h-16 w-16 items-center justify-center overflow-hidden rounded-full bg-bgMain">
					<div class="flex flex-col">
						<i class="fa-regular animation first fa-arrow-up translate-y-2" />
						<i class="fa-regular animation second fa-arrow-up translate-y-10" />
					</div>
				</div>
			</div>
			<div class="mt-10 flex w-[600px] flex-col items-center gap-6 text-center">
				<h2>Subscribe to our newsletter.</h2>
				<span class="text-sm">We'll send you a nice letter once per week. No spam.</span>
				<div v-if="success">Thank you for Subscribing</div>
				<form class="relative w-full" @submit="submit" v-else>
					<Input placeholder="Insert your email here" class="w-fit" type="email" :required="true" v-model="user.email" :error="errors.email && errors.email[0]" />
					<Button type="submit" label="Subscribe" class="primary absolute bottom-1.5 right-1.5 top-1.5" :processing="processing" />
				</form>
			</div>
		</section>
	</div>
</template>
<style scoped>
.content:hover .first {
	@apply -translate-y-10;
}

.content:hover .second {
	@apply -translate-y-2;
}
</style>
